import { Component, HostListener, OnInit } from '@angular/core';
import { GridDataResult, PageChangeEvent, DataStateChangeEvent } from '@progress/kendo-angular-grid';
import { OrderService } from '../../../../core/services/order.service';
import { IGetInvoiceBody, IInvoiceInquiry, ICustomer, IGetInvoiceDetailsBody, IMasterData, IInvoiceInquiryDropDown, IInvoiceInquiryDetailsLbl } from '../../../../core/models';
import { State, process, orderBy } from "@progress/kendo-data-query";
import { ActivatedRoute, Router } from '@angular/router';
import { CommonService } from '../../../../core/services/common.service';
import { formatDate } from '@angular/common';
import pdfMake from "pdfmake/build/pdfmake";
import pdfFonts from "pdfmake/build/vfs_fonts";
import * as Excel from 'exceljs/dist/exceljs.min.js';
import * as ExcelProper from "exceljs";
import * as fs from 'file-saver';
import { GridSettings } from '../../../../core/common';
import { StatePersistingService } from '../../../../core/services/state-persisting.service';
import { LanguageTranslationService } from '../../../../core/services/language-translation.service';

pdfMake.vfs = pdfFonts.pdfMake.vfs;


@Component({
  selector: 'app-invoice-detail',
  templateUrl: './invoice-detail.component.html',
  styleUrls: ['./invoice-detail.component.scss']
})
export class InvoiceDetailComponent implements OnInit {
  public position = 'left';
  public position1 = 'top';
  invoiceDetailsGridData: GridDataResult;
  invoiceDetailsData: any[] = [];
  invoiceDetailsLoading: boolean;
  invoiceNumberList = [];
  loadingRelatedInvoices: boolean;
  scrHeight: any;
  scrWidth: any;
  constructor(private orderService: OrderService, private router: Router,
    private route: ActivatedRoute, private commonService: CommonService,
    private persistingService: StatePersistingService, private languageTranslationService: LanguageTranslationService) {
    const gridSettings: GridSettings = this.persistingService.get(this.orderService.readUserObject.userName + 'invoiceInquiryDetailsGridSetting');
    this.getScreenSize();  
    if (gridSettings) {
      this.gridSettings = this.mapGridSettings(gridSettings);
    } else {
      // you can rest gridSettings
    }
  }
  invoicedetailsHeaderData: IInvoiceInquiry;
  invoiceInquiryGridData: IInvoiceInquiry;
  billingAddress: ICustomer;
  shippingAddress: ICustomer;
  isBillingAddress: boolean;
  isShippingAddress: boolean;
  invoiceNum: IInvoiceInquiryDropDown;
  loadingPDF: boolean;
  loadingExcel: boolean;

  ngOnInit() {
    this.loadLanguageTranslationData();
    this.invoicedetailsHeaderData = this.orderService.getInvoiceInquiryData();
    if (this.invoicedetailsHeaderData === undefined || this.invoicedetailsHeaderData === null) {
      this.router.navigate(['../'], { relativeTo: this.route });
    } else {
      this.isBillingAddress = false;
      this.isShippingAddress = false;
      this.loadInvoiceDetailsGrid(this.invoicedetailsHeaderData.invoiceNumber, this.invoicedetailsHeaderData.orderType);
      //sets the invoice number dropdown data
      this.invoiceNum = { invoiceNumber: this.invoicedetailsHeaderData.invoiceNumber, orderNumber: this.invoicedetailsHeaderData.orderNumber };
      //this.invoiceNumberList = this.orderService.getinvoiceNumberList(this.invoicedetailsHeaderData.orderNumber).filter(
      //  (thing, i, arr) => arr.findIndex(t => t.invoiceNumber === thing.invoiceNumber) === i
      //);
      this.loadRelatedInvoices(this.invoicedetailsHeaderData.invoiceNumber, this.invoicedetailsHeaderData.orderType);
    }

  }

  //#region Language translate
  loadLanguageTranslationData() {
    const controlNameList = [
      { controlName: "orderNumberLbl" },
      { controlName: "lineLbl" },
      { controlName: "orderDateLbl" },
      { controlName: "orderTypeLbl" },
      { controlName: "qtyLbl" },
      { controlName: "uomLbl" },
      { controlName: "itemLbl" },
      { controlName: "descriptionLbl" },
      { controlName: "unitPriceLbl" },
      { controlName: "extendedPriceLbl" },
      { controlName: "shipFromLbl" },
      { controlName: "statusLbl" },
      { controlName: "exportToPdfLbl" },
      { controlName: "exportToExcelLbl" },
      { controlName: "relatedinvoiceLbl" },
      { controlName: "invoiceHeaderLbl" },
      { controlName: "billingAddressLbl" },
      { controlName: "shippingAddressLbl" },
      { controlName: "invoiceNumberLbl" },
      { controlName: "jobNameLbl" },
      { controlName: "grossAmountLbl" },
      { controlName: "taxableAmountLbl" },
      { controlName: "invoiceDateLbl" },
      { controlName: "openAmountLbl" },
      { controlName: "taxLbl" },
      { controlName: "invoiceDetailsLbl" },
      { controlName: "nonTaxableLbl" },
      { controlName: "kdRefLbl" },
    ];
    const componentName = "invoiceInquiryDetail";
    const response = this.languageTranslationService.getLanguageTranslationList(controlNameList, componentName);
    if (response.length > 0) {
      this.invDetailText = response[response.length - 1];
      console.log(response);
      this.initializeGridHeader();
    }
  }
  //#endregion
  //#region label declaration
  protected invoiceDetail = {
    orderNumberLbl: 'Order#',
    lineLbl: 'Line #',
    orderDateLbl: 'Order Date',
    orderTypeLbl: 'Order Type',
    qtyLbl: 'Qty',
    uomLbl: 'UOM',
    itemLbl: 'Item #',
    descriptionLbl: 'Description',
    unitPriceLbl: 'Unit Price',
    extendedPriceLbl: 'Extended Price',
    shipFromLbl: 'Ship From',
    statusLbl: 'Status',
    exportToPdfLbl: 'Export to PDF',
    exportToExcelLbl: 'Export to Excel',
    relatedinvoiceLbl: 'Related Invoices',
    invoiceHeaderLbl: 'Invoice Header',
    billingAddressLbl: 'Billing Address',
    shippingAddressLbl: 'Shipping Address',
    invoiceNumberLbl: 'Invoice #',
    jobNameLbl: 'Job Name',
    grossAmountLbl: 'Gross Amount',
    taxableAmountLbl: 'Taxable Amount',
    invoiceDateLbl: 'Invoice Date',
    openAmountLbl: 'Open Amount',
    taxLbl: 'Tax',
    invoiceDetailsLbl: 'Invoice Details',
    nonTaxableLbl: 'Non-Taxable Amount',
    kdRefLbl: 'KD Reference Number',
    customerNumberLbl: 'Customer Number',
    customerNameLbl: 'Customer Name',

  };
  invDetailText: IInvoiceInquiryDetailsLbl = {
    relatedinvoiceLbl: '',
    invoiceHeaderLbl: '',
    billingAddressLbl: '',
    shippingAddressLbl: '',
    invoiceNumberLbl: '',
    jobNameLbl: '',
    grossAmountLbl: '',
    taxableAmountLbl: '',
    invoiceDateLbl: '',
    openAmountLbl: '',
    taxLbl: '',
    invoiceDetailsLbl: '',
    orderNumberLbl: '',
    lineLbl: '',
    orderDateLbl: '',
    orderTypeLbl: '',
    qtyLbl: '',
    uomLbl: '',
    itemLbl: '',
    descriptionLbl: '',
    unitPriceLbl: '',
    extendedPriceLbl: '',
    shipFromLbl: '',
    statusLbl: '',
    exportToPdfLbl: '',
    exportToExcelLbl: '',
    nonTaxableLbl: '',
    kdRefLbl: '',
    customerNumberLbl: '',
    customerNameLbl: '',
  }
  //#endregion


  onlyUnique(value, index, self) {
    return self.indexOf(value) === index;
  }
  private loadRelatedInvoices(invoiceNumber, orderType: string): void {
    this.loadingRelatedInvoices = true;
    const body = {
      invoiceNumber: invoiceNumber.toString(),
      orderBu: this.invoicedetailsHeaderData.orderBu,
      orderNumber: this.invoicedetailsHeaderData.orderNumber,
      orderType: orderType
    }
    this.orderService.getRelatedInvoices(body as IGetInvoiceDetailsBody).subscribe((response: Array<any>) => {
      if (response) {
        this.invoiceNumberList = response;
        //  .filter(
        //  (thing, i, arr) => arr.findIndex(t => t.invoiceNumber === thing.invoiceNumber) === i
        //);
        this.loadingRelatedInvoices = false;
      }
    });
  }
  //#region Grid data binding
  private loadInvoiceDetailsGrid(invoiceNumber, orderType: string): void {

    this.invoiceDetailsLoading = true;
    const body = {
      invoiceNumber: invoiceNumber.toString(),
      orderBu: this.invoicedetailsHeaderData.orderBu,
      orderNumber: this.invoicedetailsHeaderData.orderNumber,
      orderType: orderType
    }
    this.orderService.getInvoiceInquiryDetails(body as IGetInvoiceDetailsBody).subscribe((response: Array<any>) => {
      console.log(response);
      this.invoiceDetailsLoading = false;
      if (response) {
        this.invoicedetailsHeaderData.shipTo = response.length > 0 ? response[0].shipTo : '3031';
        this.invoiceDetailsData = response.map((obj) => {
          obj.orderDateAsDate = obj.orderDateUIString ? new Date(obj.orderDateUIString) : null;
          return obj;
        });
        this.loadInvoiceDetailsGridData();
        this.loadAddressData(this.invoicedetailsHeaderData.billTo, 'billing'); //early loading to display in PDF and Excel
      }

    })
  }
  //#endregion
  //#region billing and shipping address   
  onHeaderTabSelected(event) {
    //index 1 is for billing address and index 2 is for shipping address
    if (event.index == 1 && this.invoicedetailsHeaderData.billTo) {
      if (this.isBillingAddress == false) {
        this.loadAddressData(this.invoicedetailsHeaderData.billTo, 'billing');
      }
    } else if (event.index == 2 && this.invoicedetailsHeaderData.shipTo) {
      if (this.isShippingAddress == false) {
        this.loadAddressData(this.invoicedetailsHeaderData.shipTo, 'shipping');
      }
    }
  }
  loadAddressData(id, type) {
    this.orderService.getAddress(id as number).subscribe((response: ICustomer) => {
      if (type == 'billing') {
        this.billingAddress = response;
        this.isBillingAddress = true;
      } else {
        this.shippingAddress = response;
        this.isShippingAddress = true;
      }
    })
  }
  protected addressLabel = {
    billingAddressLbl: 'Billing Address',
    shippingAddressLbl: 'Shipping Address'
  }
  //#region label declaration

  protected invoiceDetailsGridColumnLbl = {
    orderNumber: 'Order#',
    line: 'Line #',
    orderDate: 'Order Date',
    orderType: 'Order Type',
    qty: 'Qty',
    uom: 'UOM',
    item: 'Item #',
    description: 'Description',
    unitPrice: 'Unit Price',
    extendedPrice: 'Extended Price',
    shipFrom: 'Ship From',
    status: 'Status'
  };
  //#endregion
  //#region pagination, sorting,filtering for invoice grid

  public invoiceDetailsGridstate: State = {
    skip: 0,
    take: 10,
    group: null,
    sort: [{
      field: 'orderNumber',
      dir: 'desc'
    }],
    filter: {
      logic: 'and',
      filters: []
    },
  };


  private loadInvoiceDetailsGridData(): void {
    this.invoiceDetailsGridData = process(this.invoiceDetailsData, this.invoiceDetailsGridstate);
  }

  protected invoiceGridSortChange(sort): void {
    this.invoiceDetailsGridstate.sort = sort;
    this.loadInvoiceDetailsGridData();
  }

  protected invoiceDetailsGridPageChange({ skip, take }: PageChangeEvent): void {
    this.invoiceDetailsGridstate.skip = skip;
    this.invoiceDetailsGridstate.take;
    this.loadInvoiceDetailsGridData();
  }

  public invoiceDetailsDataStateChange(state: DataStateChangeEvent): void {
    this.invoiceDetailsGridstate = state;
    this.loadInvoiceDetailsGridData();
  }

  //#endregion
  //#region Grid state save
  public gridSettings: GridSettings = {
    state: this.invoiceDetailsGridstate,
    gridData: process(this.invoiceDetailsData, this.invoiceDetailsGridstate),
    columnsConfig: [
      //  {
      //  field: 'orderNumber',
      //  title:  this.invDetailText.orderNumberLbl ? this.invDetailText.orderNumberLbl : this.invoiceDetail.orderNumberLbl,
      //  filterable: true

      //},
      {
        field: 'lineNumber',
        title: this.invDetailText.lineLbl ? this.invDetailText.lineLbl : this.invoiceDetail.lineLbl,
        filterable: true
      }, {
        field: 'orderDateAsDate',
        title: this.invDetailText.orderDateLbl ? this.invDetailText.orderDateLbl : this.invoiceDetail.orderDateLbl,
        filter: 'date',
        format: '{0:d}',//not able to get from and to
        _width: 240,
        filterable: true
      }, {
        field: 'orderType',
        title: this.invDetailText.orderTypeLbl ? this.invDetailText.orderTypeLbl : this.invoiceDetail.orderTypeLbl,
        //filter: 'date',
        //format: '{0:d}',
        //_width: 240,
        filterable: true
      }, {
        field: 'quantity',
        title: this.invDetailText.qtyLbl ? this.invDetailText.qtyLbl : this.invoiceDetail.qtyLbl,
        filterable: true
      }, {
        field: 'uom',
        title: this.invDetailText.uomLbl ? this.invDetailText.uomLbl : this.invoiceDetail.uomLbl,
        filterable: true
      }, {
        field: 'itemNumber',
        title: this.invDetailText.itemLbl ? this.invDetailText.itemLbl : this.invoiceDetail.itemLbl,
        filterable: true
      },
      {
        field: 'itemDescription',
        title: this.invDetailText.descriptionLbl ? this.invDetailText.descriptionLbl : this.invoiceDetail.descriptionLbl,
        filterable: true
      },
      {
        field: 'unitPrice',
        title: this.invDetailText.unitPriceLbl ? this.invDetailText.unitPriceLbl : this.invoiceDetail.unitPriceLbl,
        filterable: true
      },
      {
        field: 'extendedPrice',
        title: this.invDetailText.extendedPriceLbl ? this.invDetailText.extendedPriceLbl : this.invoiceDetail.extendedPriceLbl,
        filterable: true
      },
      {
        field: 'shipFrom',
        title: this.invDetailText.shipFromLbl ? this.invDetailText.shipFromLbl : this.invoiceDetail.shipFromLbl,
        filterable: true
      },
      {
        field: 'status',
        title: this.invDetailText.statusLbl ? this.invDetailText.statusLbl : this.invoiceDetail.statusLbl,
        filterable: true
      }]
  };

  public onReorder(e: any): void {
    const reorderedColumn = this.gridSettings.columnsConfig.splice(e.oldIndex, 1);
    this.gridSettings.columnsConfig.splice(e.newIndex, 0, ...reorderedColumn);
    this.saveGrid();
  }
  public onVisibilityChange(e: any): void {
    e.columns.forEach(column => {
      this.gridSettings.columnsConfig.find(col => col.field === column.field).hidden = column.hidden;
    });

    this.saveGrid();
  }

  private saveGrid(): void {
    //debugger;
    this.gridSettings.state.skip = 0;
    const gridConfig = {
      columnsConfig: this.gridSettings.columnsConfig,
      state: this.gridSettings.state
    };
    this.persistingService.set(this.orderService.readUserObject.userName + 'invoiceInquiryDetailsGridSetting', gridConfig);
  }

  public mapGridSettings(gridSettings: GridSettings): GridSettings {
    const state = gridSettings.state;
    this.mapDateFilter(state.filter);
    state.skip = 0;
    return {
      state,
      columnsConfig: gridSettings.columnsConfig.sort((a, b) => a.orderIndex - b.orderIndex),
      gridData: process(this.invoiceDetailsData, state)
    };
  }
  private mapDateFilter = (descriptor: any) => {
    const filters = descriptor.filters || [];

    filters.forEach(filter => {
      if (filter.filters) {
        this.mapDateFilter(filter);
      }
    });
  }
  //#endregion
  public onTabSelect(e) {
    console.log(e);
  }

  //#region invoice number dropdown
  invoiceNumberChange(element: any) {
    if (this.invoiceNum.invoiceNumber) {
      const rowData = this.orderService.getInvoiceInquiryGridData().find(r => r.invoiceNumber == this.invoiceNum.invoiceNumber);
      this.orderService.setInvoiceInquiryData(rowData);
      this.invoicedetailsHeaderData = this.orderService.getInvoiceInquiryData();
      this.loadInvoiceDetailsGrid(this.invoiceNum.invoiceNumber, rowData.orderType);
    }
  }
  //#endregion

  async generatePDF() {
    this.loadingPDF = true;
    
    var currFilter = this.invoiceDetailsGridstate.filter;
    var filterData = process(this.invoiceDetailsData, {
      filter: currFilter
    });
    var todaysDate = formatDate(new Date(), 'MM/dd/yyyy', 'en');
    let docDefinition = {
      header: {
        columns: [
          { text: todaysDate, margin: [10, 12, 10, 20] },
          { text: this.invDetailText.invoiceDetailsLbl ? this.invDetailText.invoiceDetailsLbl : this.invoiceDetail.invoiceDetailsLbl, alignment: 'center', margin: [10, 12, 0, 20] }
        ]
      },
      content: [
        {
          // under NodeJS (or in case you use virtual file system provided by pdfmake)
          // you can also pass file names here
          image: await this.commonService.getBase64ImageFromURL(
            location.origin.toString() + "/assets/images/kawneer_logo.JPG"
          ),
          alignment: 'center', fit: [150, 150]
        },
        {
          columns: [
            [{
              text: this.invDetailText.customerNumberLbl ? this.invDetailText.customerNumberLbl : this.invoiceDetail.customerNumberLbl + ": " + this.orderService.readUserObject.customerNumber,
              bold: true,
              margin: [0, 15, 0, 15]
            },
            {
              text: this.invDetailText.customerNameLbl ? this.invDetailText.customerNameLbl : this.invoiceDetail.customerNameLbl + ": " + this.orderService.readUserObject.customerName,
              bold: true,
              margin: [0, 15, 0, 15]
            }],
            [{
              text: this.invDetailText.invoiceNumberLbl ? this.invDetailText.invoiceNumberLbl : this.invoiceDetail.invoiceNumberLbl + ": " + this.invoicedetailsHeaderData.invoiceNumber,
              margin: [0, 2, 0, 2]
            },
            {
                text: this.invDetailText.jobNameLbl ? this.invDetailText.jobNameLbl : this.invoiceDetail.jobNameLbl + ": " + this.invoicedetailsHeaderData.jobName,
                margin: [0, 2, 0, 2]
            },
            {
              text: this.invDetailText.grossAmountLbl ? this.invDetailText.grossAmountLbl : this.invoiceDetail.grossAmountLbl + ": " + this.commonService.formatCurrencyTwodigit(this.invoicedetailsHeaderData.grossAmount),
              margin: [0, 2, 0, 2]
            },
            {
              text: this.invDetailText.taxableAmountLbl ? this.invDetailText.taxableAmountLbl : this.invoiceDetail.taxableAmountLbl + ": " + this.commonService.formatCurrencyTwodigit(this.invoicedetailsHeaderData.taxableAmount),
              margin: [0, 2, 0, 2]
            },
            {
              text: this.invDetailText.invoiceDateLbl?this.invDetailText.invoiceDateLbl:this.invoiceDetail.invoiceDateLbl + ": " + this.invoicedetailsHeaderData.invoiceDateUIString,
              margin: [0, 2, 0, 2]
            },
            {
              text: this.invDetailText.openAmountLbl ? this.invDetailText.openAmountLbl : this.invoiceDetail.openAmountLbl + ": " + this.commonService.formatCurrencyTwodigit(this.invoicedetailsHeaderData.openAmount),
              margin: [0, 2, 0, 2]
            },
            {
              text: this.invDetailText.taxLbl ? this.invDetailText.taxLbl : this.invoiceDetail.taxLbl + ": " + this.commonService.formatCurrencyTwodigit(this.invoicedetailsHeaderData.tax),
              margin: [0, 2, 0, 2]
            },
            {
              text: this.invDetailText.kdRefLbl?this.invDetailText.kdRefLbl:this.invoiceDetail.kdRefLbl + ": " + this.invoicedetailsHeaderData.kdReferenceNumber,
              margin: [0, 2, 0, 2]
            },
            {
              text: this.invDetailText.nonTaxableLbl ? this.invDetailText.nonTaxableLbl : this.invoiceDetail.nonTaxableLbl + ": " + this.commonService.formatCurrencyTwodigit(this.invoicedetailsHeaderData.nonTaxableAmount),
              margin: [0, 2, 0, 2]
            }
          ]
          ],
        },
        {
          text: this.addressLabel.billingAddressLbl,
          style: 'sectionHeader'
        },
        {
          columns: [
            [
              {
                text: this.billingAddress ? (this.billingAddress.addressLine1 ? this.billingAddress.addressLine1 : ""
                  + "" + this.billingAddress.addressLine2) : ""
              },
              {
                text: this.billingAddress ? (this.billingAddress.city + ", " + this.billingAddress.state + " "
                  + this.billingAddress.zipCode) : ""
              }
            ]
          ]
        },
        // {  
        //     text: this.addressLabel.shippingAddressLbl,  
        //     style: 'sectionHeader'  
        // },
        // {
        //   columns: [
        //     [
        //       { text: '2762 - ROYAL GLASS CO INC'},
        //       { text: '3200 DE LA CRUZ BLVD.' },
        //       { text: 'SANTA CLARA, CA 95054' }
        //       // { text: this.shippingAddress?.addressLine1 + "" + this.shippingAddress?.addressLine2},
        //       // { text: this.billingAddress.city + "," + this.billingAddress.state + " " + this.billingAddress.zipCode }
        //     ]
        //   ]
        // },
        // {  
        //     text: 'Invoice Header',  
        //     style: 'sectionHeader'  
        // },
        // {
        //   columns: [
        //     [
        //       { 
        //         text: this.invoicedetailsHeaderData.jobName,
        //         bold: true
        //       },
        //       { text: 'Invoice #: ' + this.invoicedetailsHeaderData.invoiceNumber },
        //       { text: 'Invoice Date: ' + this.invoicedetailsHeaderData.invoiceDate },
        //       { text: 'Gross Amount: 480.00' },
        //       { text: 'Open Amount: 0.00' },
        //       { text: 'Taxable Amount: 0.00' }
        //     ]
        //   ]
        // },
        {
          text: this.invDetailText.invoiceDetailsLbl ? this.invDetailText.invoiceDetailsLbl : this.invoiceDetail.invoiceDetailsLbl,
          style: 'sectionHeader'
        },
        {
          style: 'tableStyle',
          table: {
            headerRows: 1,
            widths: [26, 40, 25, 15, 30, 50, 50, 40, 60, 50, 37],
            body: [
              [
                this.invDetailText.lineLbl ? this.invDetailText.lineLbl : this.invoiceDetail.lineLbl,
                this.invDetailText.orderDateLbl ? this.invDetailText.orderDateLbl : this.invoiceDetail.orderDateLbl,
                this.invDetailText.orderTypeLbl ? this.invDetailText.orderTypeLbl : this.invoiceDetail.orderTypeLbl,
                this.invDetailText.qtyLbl ? this.invDetailText.qtyLbl : this.invoiceDetail.qtyLbl,
                this.invDetailText.uomLbl ? this.invDetailText.uomLbl : this.invoiceDetail.uomLbl,
                this.invDetailText.itemLbl ? this.invDetailText.itemLbl : this.invoiceDetail.itemLbl,
                this.invDetailText.descriptionLbl ? this.invDetailText.descriptionLbl : this.invoiceDetail.descriptionLbl,
                this.invDetailText.unitPriceLbl ? this.invDetailText.unitPriceLbl : this.invoiceDetail.unitPriceLbl,
                this.invDetailText.extendedPriceLbl ? this.invDetailText.extendedPriceLbl : this.invoiceDetail.extendedPriceLbl,
                this.invDetailText.shipFromLbl ? this.invDetailText.shipFromLbl : this.invoiceDetail.shipFromLbl,
                this.invDetailText.statusLbl ? this.invDetailText.statusLbl : this.invoiceDetail.statusLbl
              ],
              ...filterData.data.map(p =>
              ([
                //p.orderNumber,
                p.lineNumber ? p.lineNumber : '',
                p.orderDateUIString ? p.orderDateUIString : '',
                p.orderType ? p.orderType : '',
                p.quantity,
                p.uom ? p.uom : '',
                p.itemNumber ? p.itemNumber : '',
                p.itemDescription ? p.itemDescription : '',
                (p.invoiceLineDetail == 'N' && p.itemNumber != 'FRT') ? '' : (p.unitPrice ? p.unitPrice : ''),
                (p.invoiceLineDetail == 'N' && p.itemNumber != 'FRT') ? '' : (p.extendedPrice ? p.extendedPrice : ''),
                p.shipFrom ? p.shipFrom : '',
                p.status ? p.status : '',
              ])
              )
            ]
          }
        }
      ],
      footer: {
        columns: [
          { text: '©1991-2021 Arconic. All rights reserved.', alignment: 'center' }
        ]
      },
      styles: {
        headerLeft: {
          fontSize: 22,
        },
        headerRight: {
          fontSize: 22,
          alignment: 'center'
        },
        anotherStyle: {
          italics: true,
          alignment: 'right'
        },
        sectionHeader: {
          bold: true,
          decoration: 'underline',
          fontSize: 14,
          margin: [0, 15, 0, 15]
        },
        tableStyle: {
          fontSize: 8
        }
      }
    };

    pdfMake.createPdf(docDefinition).download("InvoiceDetails.pdf");
    this.loadingPDF = false;
  }
  generateExcel() {
    this.loadingExcel = true;
    
    var currFilter = this.invoiceDetailsGridstate.filter;
    var filterData = process(this.invoiceDetailsData, {
      filter: currFilter
    });
    let workbook: ExcelProper.Workbook = new Excel.Workbook();
    let worksheet = workbook.addWorksheet(this.invDetailText.invoiceDetailsLbl ? this.invDetailText.invoiceDetailsLbl : this.invoiceDetail.invoiceDetailsLbl);
    // const invoiceHeaderData = [
    //   ['Invoice #: ', this.invoicedetailsHeaderData.invoiceNumber, 'Gross Amount: ', '480.00', 'Taxable Amount: ', '0.00'],
    //   ['Invoice Date: ', this.invoicedetailsHeaderData.invoiceDate, 'Open Amount: ', '0.00', '', '']
    // ];
    const header = [
      this.invDetailText.lineLbl ? this.invDetailText.lineLbl : this.invoiceDetail.lineLbl,
      this.invDetailText.orderDateLbl ? this.invDetailText.orderDateLbl : this.invoiceDetail.orderDateLbl,
      this.invDetailText.orderTypeLbl ? this.invDetailText.orderTypeLbl : this.invoiceDetail.orderTypeLbl,
      this.invDetailText.qtyLbl ? this.invDetailText.qtyLbl : this.invoiceDetail.qtyLbl,
      this.invDetailText.uomLbl ? this.invDetailText.uomLbl : this.invoiceDetail.uomLbl,
      this.invDetailText.itemLbl ? this.invDetailText.itemLbl : this.invoiceDetail.itemLbl,
      this.invDetailText.descriptionLbl ? this.invDetailText.descriptionLbl : this.invoiceDetail.descriptionLbl,
      this.invDetailText.unitPriceLbl ? this.invDetailText.unitPriceLbl : this.invoiceDetail.unitPriceLbl,
      this.invDetailText.extendedPriceLbl ? this.invDetailText.extendedPriceLbl : this.invoiceDetail.extendedPriceLbl,
      this.invDetailText.shipFromLbl ? this.invDetailText.shipFromLbl : this.invoiceDetail.shipFromLbl,
      this.invDetailText.statusLbl ? this.invDetailText.statusLbl : this.invoiceDetail.statusLbl
    ];
    worksheet.addRow([]);
    worksheet.addRow([]);
    worksheet.addRow([]);
    worksheet.addRow([]);
    worksheet.addRow([]);
    worksheet.addRow(['', '', '', '', this.invDetailText.invoiceNumberLbl ? this.invDetailText.invoiceNumberLbl : this.invoiceDetail.invoiceNumberLbl + ": " + this.invoicedetailsHeaderData.invoiceNumber]);
    worksheet.addRow(['', '', '', '', this.invDetailText.jobNameLbl ? this.invDetailText.jobNameLbl : this.invoiceDetail.jobNameLbl + ": " + this.invoicedetailsHeaderData.jobName]);
    worksheet.addRow(['', '', '', '', this.invDetailText.grossAmountLbl ? this.invDetailText.grossAmountLbl : this.invoiceDetail.grossAmountLbl + ": " + this.commonService.formatCurrencyTwodigit(this.invoicedetailsHeaderData.grossAmount),]);
    worksheet.addRow([this.invDetailText.customerNumberLbl ? this.invDetailText.customerNumberLbl : this.invoiceDetail.customerNumberLbl + ":" + this.orderService.readUserObject.customerNumber + '', '', '', '', this.invDetailText.taxableAmountLbl ? this.invDetailText.taxableAmountLbl : this.invoiceDetail.taxableAmountLbl + ": " + this.commonService.formatCurrencyTwodigit(this.invoicedetailsHeaderData.taxableAmount)]);
    worksheet.addRow(['', '', '', '', this.invDetailText.invoiceDateLbl ? this.invDetailText.invoiceDateLbl : this.invoiceDetail.invoiceDateLbl + ": " + this.invoicedetailsHeaderData.invoiceDateUIString]);
    worksheet.addRow([this.invDetailText.customerNameLbl ? this.invDetailText.customerNameLbl : this.invoiceDetail.customerNameLbl + ":" + this.orderService.readUserObject.customerName + '', '', '', '', this.invDetailText.openAmountLbl ? this.invDetailText.openAmountLbl : this.invoiceDetail.openAmountLbl + ": " + this.commonService.formatCurrencyTwodigit(this.invoicedetailsHeaderData.openAmount)]);
    worksheet.addRow(['', '', '', '', this.invDetailText.taxLbl ? this.invDetailText.taxLbl : this.invoiceDetail.taxLbl + ": " + this.commonService.formatCurrencyTwodigit(this.invoicedetailsHeaderData.tax)]);
    worksheet.addRow(['', '', '', '', this.invDetailText.kdRefLbl ? this.invDetailText.kdRefLbl : this.invoiceDetail.kdRefLbl + ": " + this.invoicedetailsHeaderData.kdReferenceNumber]);
    worksheet.addRow(['', '', '', '', this.invDetailText.nonTaxableLbl ? this.invDetailText.nonTaxableLbl : this.invoiceDetail.nonTaxableLbl + ": " + this.commonService.formatCurrencyTwodigit(this.invoicedetailsHeaderData.nonTaxableAmount)]);
    worksheet.columns[0].width = 40;
    //let ClientIdRow = worksheet.addRow([this.invDetailText.customerNumberLbl ? this.invDetailText.customerNumberLbl : this.invoiceDetail.customerNumberLbl + ":" + this.orderService.readUserObject.customerNumber + '']);
    //ClientIdRow.font = { size: 10, bold: true }
    //worksheet.addRow([]);
    //let ClientNameRow = worksheet.addRow([this.invDetailText.customerNameLbl ? this.invDetailText.customerNameLbl : this.invoiceDetail.customerNameLbl + ":" + this.orderService.readUserObject.customerName + '']);
    //ClientNameRow.font = { size: 10, bold: true }
    worksheet.addRow([]);
    worksheet.addRow([]);
    let billingAddressHeaderRow = worksheet.addRow([this.addressLabel.billingAddressLbl]);
    billingAddressHeaderRow.font = { size: 10, underline: 'double', bold: true }
    worksheet.addRow([this.billingAddress ? (this.billingAddress.addressLine1 + ""
      + this.billingAddress.addressLine2) : '']);
    worksheet.addRow([this.billingAddress ? (this.billingAddress.city + "," + this.billingAddress.state + " "
      + this.billingAddress.zipCode) : '']);
    worksheet.addRow([]);
    worksheet.addRow([]);
    // let shippingAddressHeaderRow = worksheet.addRow([this.addressLabel.shippingAddressLbl]);
    // shippingAddressHeaderRow.font = { size: 10, underline: 'double', bold: true };
    // worksheet.addRow(['2762 - ROYAL GLASS CO INC']);
    // worksheet.addRow([ '3200 DE LA CRUZ BLVD.']);
    // worksheet.addRow(['SANTA CLARA, CA 95054']);
    // worksheet.addRow([]);
    // worksheet.addRow([]);
    // let invoiceHeaderRow = worksheet.addRow(['Invoice Header']);
    // invoiceHeaderRow.font = { size: 10, underline: 'double', bold: true };
    // invoiceHeaderData.forEach(d => {
    //   let row = worksheet.addRow(d);
    //   });
    // worksheet.addRow([]);
    // worksheet.addRow([]);
    let invoiceDetailsRow = worksheet.addRow([this.invDetailText.invoiceDetailsLbl ? this.invDetailText.invoiceDetailsLbl : this.invoiceDetail.invoiceDetailsLbl]);
    invoiceDetailsRow.font = { size: 10, underline: 'double', bold: true };
    //Add Header row
    let headerRow = worksheet.addRow(header);

    // Cell Style : Fill and Border
    headerRow.eachCell((cell, number) => {
      cell.fill = {
        type: 'pattern',
        pattern: 'solid',
        fgColor: { argb: 'FFFFFF00' },
        bgColor: { argb: 'FF0000FF' }
      }
      cell.border = { top: { style: 'thin' }, left: { style: 'thin' }, bottom: { style: 'thin' }, right: { style: 'thin' } }
    })
    filterData.data.map(p =>
    ([
      //p.orderNumber,
      p.line ? p.line : '',
      p.orderDateUIString ? p.orderDateUIString : '',
      p.orderType ? p.orderType : '',
      p.quantity,
      p.uom ? p.uom : '',
      p.itemNumber ? p.itemNumber : '',
      p.itemDescription ? p.itemDescription : '',
      (p.invoiceLineDetail == 'N' && p.itemNumber != 'FRT') ? '' : (p.unitPrice ? p.unitPrice : ''),
      (p.invoiceLineDetail == 'N' && p.itemNumber != 'FRT') ? '' : (p.extendedPrice ? p.extendedPrice : ''),
      p.shipFrom ? p.shipFrom : '',
      p.status ? p.status : ''
    ])
    ).forEach(d => {
      let row = worksheet.addRow(d);
    });
    worksheet.addRow([]);
    workbook.xlsx.writeBuffer().then((data) => {
      let blob = new Blob([data], { type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet' });
      fs.saveAs(blob, 'InvoiceData.xlsx');
    })
    this.loadingExcel = false;
  }

  initializeGridHeader() {

    this.gridSettings.columnsConfig.forEach((el) => {

      if (el.field == 'lineNumber') {
        el.title = this.invDetailText.lineLbl ? this.invDetailText.lineLbl : this.invoiceDetail.lineLbl;
      }
      if (el.field == 'orderDateAsDate') {
        el.title = this.invDetailText.orderDateLbl ? this.invDetailText.orderDateLbl : this.invoiceDetail.orderDateLbl;
      }
      if (el.field == 'orderType') {
        el.title = this.invDetailText.orderTypeLbl ? this.invDetailText.orderTypeLbl : this.invoiceDetail.orderTypeLbl;
      }
      if (el.field == 'quantity') {
        el.title = this.invDetailText.qtyLbl ? this.invDetailText.qtyLbl : this.invoiceDetail.qtyLbl;
      }
      if (el.field == 'uom') {
        el.title = this.invDetailText.uomLbl ? this.invDetailText.uomLbl : this.invoiceDetail.uomLbl;
      }
      if (el.field == 'itemNumber') {
        el.title = this.invDetailText.itemLbl ? this.invDetailText.itemLbl : this.invoiceDetail.itemLbl;
      }
      if (el.field == 'itemDescription') {
        el.title = this.invDetailText.descriptionLbl ? this.invDetailText.descriptionLbl : this.invoiceDetail.descriptionLbl;
      }
      if (el.field == 'unitPrice') {
        el.title = this.invDetailText.unitPriceLbl ? this.invDetailText.unitPriceLbl : this.invoiceDetail.unitPriceLbl;
      }
      if (el.field == 'extendedPrice') {
        el.title = this.invDetailText.extendedPriceLbl ? this.invDetailText.extendedPriceLbl : this.invoiceDetail.extendedPriceLbl;
      }
      if (el.field == 'shipFrom') {
        el.title = this.invDetailText.shipFromLbl ? this.invDetailText.shipFromLbl : this.invoiceDetail.shipFromLbl;
      }
      if (el.field == 'status') {
        el.title = this.invDetailText.statusLbl ? this.invDetailText.statusLbl : this.invoiceDetail.statusLbl;
      }
    });
  }
    public onFilterInvoiceDetail(inputValue: string): void {

        this.invoiceDetailsGridData = process(this.invoiceDetailsData, {
            filter: {
                logic: "or",
                filters: [

                    //{
                    //  field: "orderDateAsDate",
                    //  operator: "contains",
                    //  value: inputValue,
                    //},
                    //{
                    //  field: "orderType",
                    //  operator: "contains",
                    //  value: inputValue,
                    //},
                    {
                        field: "itemNumber",
                        operator: "contains",
                        value: inputValue,
                    },
                    {
                        field: "itemDescription",
                        operator: "contains",
                        value: inputValue,
                    },
                    {
                        field: "shipFrom",
                        operator: "contains",
                        value: inputValue,
                    },
                    {
                        field: "status",
                        operator: "contains",
                        value: inputValue,
                    }
                ],
            },
        });
        if (!inputValue) {
            this.invoiceDetailsGridstate.skip = 0;
            this.invoiceDetailsGridstate.take = 10;
            this.loadInvoiceDetailsGridData();
        }
    }
  @HostListener('window:resize', ['$event'])
  getScreenSize(event?) {
    this.scrHeight = window.innerHeight;
    this.scrWidth = window.innerWidth;   
    if (this.scrWidth <= 1024) {
      this.position = 'top';
    }
    else {
      this.position = 'left';
    }
  }
}
